// 📁 src/components/ContactTableView.jsx
import React from "react";
import { Paper } from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";

import { createProcessRowUpdate } from "../utils/processRowUpdate.js";
import { logDev } from "../utils/logger.js";

const ContactTableView = ({ contacts, columns, groupeId, setContacts }) => {
  const apiRef = useGridApiRef(); // ✅ déclaration

  // 📝 Log au rendu
  logDev("[ContactTableView] rendu", { nbContacts: contacts.length, groupeId, colonnes: columns.map(c => c.field) });

  return (
  
  <Paper className="table-container">

    <DataGrid
      apiRef={apiRef} // ✅ passage au DataGrid
      rows={contacts}
      columns={columns}
      getRowId={(row) => row._id}
      processRowUpdate={createProcessRowUpdate(groupeId, [], setContacts)}
      onProcessRowUpdateError={(err) => logDev("[ContactTableView] erreur édition", err)}
      autoHeight
      pagination
      pageSizeOptions={[5, 10, 25]}
      disableColumnMenu
      columnBuffer={2}
      editMode="cell"   // 👈 suffit pour activer l’édition au clic
      experimentalFeatures={{ newEditingApi: true }}
      sx={{
          backgroundColor: "#e4dcd2",
          "& .total-row": {
            fontWeight: "bold",
            backgroundColor: "#d9cbb8",
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#e4dcd2',
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#e4dcd2",
            color: "#555",
          },
          "& .MuiDataGrid-sortIcon": {
            backgroundColor: "transparent"
          },
          "& .MuiDataGrid-columnSeparator": {
            color: "#999",
            visibility: "visible",
            opacity: 1,
          }
        }}
      initialState={{
        pagination: { paginationModel: { pageSize: 10, page: 0 } }
      }}
    />
  </Paper>
);
};

export default ContactTableView;
